__turbopack_context__.v({
  "alsoKnownAs": "breedResultsHeader-module-scss-module__nUQKfG__alsoKnownAs",
  "breadcrumbWrapper": "breedResultsHeader-module-scss-module__nUQKfG__breadcrumbWrapper",
  "header": "breedResultsHeader-module-scss-module__nUQKfG__header",
  "headerText": "breedResultsHeader-module-scss-module__nUQKfG__headerText",
});
